import React, { Component } from 'react';
import Input from 'Components/Input';
import Dropdown from 'Components/Dropdown/dropdown';
import { ReactComponent as UploadIcon } from "Icons/upload-blue.svg";
import { ReactComponent as DownloadIcon } from "Icons/download.svg";
import Upload from 'Components/Upload';
import LCLContract from './lclContract';
import FTLContract from './ftlContract';
import CFAContract from './CFAContract';
import DedicatedContracts from './dedicatedContract';
import Moment from 'moment';
import Cx from 'classnames';
import { SingleDatePicker } from 'react-dates';
import { ABFRL } from 'Constants/commonConstants';
import { getUser } from 'Utils/storage';

const MOVEMENT_TYPE = [
    {name: 'Inbound', value: 1},
    {name: 'Outbound', value: 2}
]

const APPLICABLE_TYPES = [
    {name: 'Applicable', value: true},
    {name: 'Not-Applicable', value: false}
]

const SERVICE_MODES = [
    {name: 'Rail', value: 1},
    {name: 'Road', value: 2},
    {name: 'Air', value: 3},
    {name: 'Bus', value: 4},
    {name: 'MILK Run Same Day', value: 5},
    {name: 'MILK Run Next Day', value: 6},
    {name: 'Dedicated', value: 7},
    {name: 'Regular', value: 8}
]

const DISTRIBUTION_TYPES = [
    {name: 'Primary ( Vendors to DC)', value: 1},
    {name: 'Secondary ( DC to stores)', value: 2},
    {name: 'Store to store', value: 3},
    {name: 'Store to DC', value: 4},
    {name: 'DC to DC', value: 5}
]


class TripDetails extends Component {
    constructor() {
        super();
        this.state = {
        }
    }

    validate=()=>{
        const { contract_type_id  } = this.props.data;
        if (contract_type_id === 1) {
            return this.validateLcl();
        } 
        else if (contract_type_id === 2) {
            return this.validateCourierContract();
        }
        else if (contract_type_id === 3) {
            return this.validateDedicated();
        }
        else if (contract_type_id === 4) {
            return this.validateCfa();
        }
        else if (contract_type_id === 5) {
            return this.validateFtl();
        }
        return false; 
    } 

       
   validateLcl = () => {
    const { data: { trips = [], ...Data } } = this.props;
    let errorFlag = true;
    
   if (
      (Data.dph_applicable === true &&
         (Data.diesel_price_rate && Data.diesel_price_date) || !Data.dph_applicable) && 
       Data.movement_type &&
        Data.pricing_basis_id &&
        (typeof Data.tat_master_applicable === 'boolean') &&
          Data.service_mode_id &&
           Data.distribution_mode_id && 
       trips.length > 0 && trips.every(trip => trip.from_zone &&
         trip.to_zone &&
          trip.to &&
           trip.from &&
            trip.qbr &&
             trip.stops[0].location && trip.stops[0].state &&
       trip.stops[1].state && trip.stops[1].location &&
        (Data.tat_master_applicable ? ((trip.tat || {}).name && (trip.tat || {}).value && (trip.tat || {}).unit ) : true) ) 
      ) {
        errorFlag = false;
      }
     return errorFlag;
    }

    validateCourierContract = () => {
        
        const { data: { trips = [], ...Data } } = this.props;
        console.log(Data,trips)
        let errorFlag = true;    
            if (
            Data.movement_type &&
            Data.pricing_basis &&
            Data.service_mode_name &&
            Data.distribution_mode_name &&
            Data.diesel_price_rate &&
            Data.diesel_price_date &&
            trips.length > 0 &&
            trips.every(trip => trip.from_zone &&
                trip.to_zone &&
                trip.to && trip.from &&            
                (trip.tat || {}).name &&
                (trip.tat || {}).value &&
                (trip.tat || {}).unit &&
                trip.qbr &&  trip.stops[0].location && 
                trip.stops[0].state && 
                trip.stops[1].location && 
                trip.stops[1].state &&
                 trip.minimum_quantity &&
                 trip.minimum_quantity_uom &&
                 trip.variable_cost &&
                 trip.variable_quantity &&
                 trip.variable_quantity_uom  
            ))
       {
            errorFlag = false
        }
        return errorFlag;
    }     


    validateDedicated = () => {
        const { data: { trips = [], ...Data } } = this.props;
        let errorFlag = true;    
            if (
                (Data.dph_applicable === true &&
                    (Data.diesel_price_rate && Data.diesel_price_date) || !Data.dph_applicable) &&
            Data.movement_type &&
            Data.pricing_basis_id &&
            Data.service_mode_id &&
            Data.distribution_mode_id &&
            // Data.diesel_price_rate &&
            // Data.diesel_price_date &&
            trips.length > 0 &&
            trips.every(trip => ((trip.stops[0].location || 
                trip.stops[0].state || 
                trip.from_zone) && 
                (trip.stops[1].location || 
                trip.stops[1].state || 
                trip.to_zone) && 
                trip.qbr &&
                // trip.minimum_quantity && 
                // trip.minimum_quantity_uom && 
                trip.vehicle_type_id &&
                // trip.dedicated_variable_cost.every(
                //     (dedicatedCost) => dedicatedCost.variable_cost && 
                // dedicatedCost.variable_quantity && dedicatedCost.variable_quantity_uom
                // ) &&
                trip.touch_points.every((el) => (el.location || el.state || el.point_type) ? (el.location && el.state && el.point_type) : true)
                && (trip.tat || {}).name &&
                (trip.tat || {}).value &&
                 (trip.tat || {}).unit 
                ))
            ) {
            errorFlag = false;
            }
            return errorFlag;
        }

    validateCfa = () => {
        const { data: { trips = [], ...Data } } = this.props;
        let errorFlag = true;
        
        if (
        trips.length > 0 &&
        trips.every(trip => 
            trip.stops[0].city &&
            trip.type_of_charges &&
            trip.monthly_amount &&
            trip.gst_applicability &&
            (trip.gst_applicability === "Yes" ? trip.gst_percentage : true)
        )
        ) {
        errorFlag = false;
        }
        
        return errorFlag;
    }

    validateFtl = () => {
                const { data: { trips = [], ...Data } } = this.props;
                let errorFlag = true;    
                                if ((Data.dph_applicable === true &&
                                    (Data.diesel_price_rate && Data.diesel_price_date) || !Data.dph_applicable) &&
                                    Data.movement_type &&
                                    Data.pricing_basis_id &&
                                    Data.service_mode_id &&
                                    Data.distribution_mode_id &&
                                    // Data.diesel_price_rate &&
                                    // Data.diesel_price_date &&
                                    trips.length > 0 &&
                                    trips.every(trip =>( (trip.stops[0].location || 
                                        trip.stops[0].state || 
                                        trip.from_zone) && 
                                        // trip.to && trip.from &&
                                        (trip.stops[1].location || 
                                        trip.stops[1].state || 
                                        trip.to_zone ) && 
                                        trip.touch_points.every((el) => (el.location || el.state || el.point_type) ? (el.location && el.state && el.point_type) : true) &&
                                        trip.qbr &&
                                        // trip.minimum_quantity &&
                                        // trip.minimum_quantity_uom &&
                                        trip.vehicle_type_id  
                                        // trip.variable_cost &&
                                        // trip.variable_quantity &&
                                        // trip.variable_quantity_uom  
                                        && (trip.tat || {}).name &&
                                        (trip.tat || {}).value &&
                                         (trip.tat || {}).unit              
                                         ))                                        
                                            ) {
                                            errorFlag = false;
                                            }
                                            return errorFlag;
                                    }
                                    nonMandatoryConditions=()=>{
                                        const C1 = ABFRL.includes(getUser().companyId);
                                        if(C1){
                                            return false;
                                        }
                                        return true;
                                    }
       
    render() {
        const { data, pricingBasis, vehicleTypes, isView, onChangeDedicatedVC, onDeleteDedicatedVC, onAddDedicatedVC, cfaDetails, isEdit, searchText} = this.props;
        return (
            <div className='pv-20 ph-20'>
                {data.contract_type_id !== 4 && <div className={Cx('ht-90 flex flex-wrap pt-20 ph-20 bg-white br-5', {
                    'disable-pointer-events': isView
                })} style={{'border': '1px solid #85919E'}}>
                    <div className='wt-200 mr-20 mb-20'>
                            <div className='fs-16 fSemibold mb-2'>Movement Type <span style={{ color: 'red' }}>*</span></div>
                            <Dropdown 
                                className="border-dblue" 
                                inputClassName={" ht-15"}                 
                                widthValue={'wt-200'}
                                items={MOVEMENT_TYPE}
                                name="movement_type" 
                                displayKey="name" 
                                label="Select"
                                selectedItem={data.movement_type && MOVEMENT_TYPE.find(el => el.value === data.movement_type)}
                                onSelect={(name) => {
                                    const movementType = (MOVEMENT_TYPE || []).find(el => el.name === name)
                                    this.props.onSelect(movementType, 'movement_type_name', 'movement_type')
                                }}
                            />
                    </div>
                    <div className='wt-400 mr-20 mb-20'>
                            <div className='fs-16 fSemibold mb-2'>Pricing Basis <span style={{ color: 'red' }}>*</span></div>
                            <Dropdown 
                                className="border-dblue" 
                                inputClassName={" ht-15"}
                                widthValue={'wt-400'}
                                items={pricingBasis}
                                name="pricing_basis" 
                                displayKey="name" 
                                label="Select"
                                selectedItem={data.pricing_basis_id && pricingBasis.find(el => el.value === data.pricing_basis_id)}
                                onSelect={(name) => {
                                    const optionList = (pricingBasis || []).find(el => el.name === name)
                                    this.props.onSelect(optionList, 'pricing_basis', 'pricing_basis_id')
                                }}
                            />
                    </div>
                    {([1,3,5].includes(data.contract_type_id))&& 
                    <>
                        <div className='wt-200 mr-20 mb-20'>
                                <div className='fs-16 fSemibold mb-2'>DPH <span style={{ color: 'red' }}>*</span></div>
                                <Dropdown 
                                    className="border-dblue" 
                                    inputClassName={" ht-15"}
                                    widthValue={'wt-200'}
                                    items={APPLICABLE_TYPES}
                                    name="dph_applicable" 
                                    displayKey="name" 
                                    label="Select"
                                    selectedItem={(typeof data.dph_applicable === 'boolean')  && APPLICABLE_TYPES.find(el => Number(el.value) === Number(data.dph_applicable))}
                                    onSelect={(name) => {
                                        const optionList = (APPLICABLE_TYPES || []).find(el => el.name === name)
                                        this.props.onSelect(optionList, 'dph_applicable_name', 'dph_applicable')
                                    }}
                                />
                        </div>
                        {data.contract_type_id === 1 && <div className='wt-200 mr-20 mb-20'>
                                <div className='fs-16 fSemibold mb-2'>TAT {data.contract_type_id === 1 && <span style={{ color: "red" }}>*</span>}</div>
                                <Dropdown 
                                    className="border-dblue" 
                                    inputClassName={" ht-15"}
                                    widthValue={'wt-200'}
                                    items={APPLICABLE_TYPES}
                                    name="movement_type" 
                                    displayKey="name" 
                                    label="Select"
                                    selectedItem={(typeof data.tat_master_applicable === 'boolean') && APPLICABLE_TYPES.find(el => Number(el.value) == Number(data.tat_master_applicable))}
                                    onSelect={(name) => {
                                        const optionList = (APPLICABLE_TYPES || []).find(el => el.name === name)
                                        this.props.onSelect(optionList, 'tat_master_applicable_name', 'tat_master_applicable')
                                    }}
                                />
                        </div>}
                    </>}
                    <div className='wt-200 mr-20 mb-20'>
                            <div className='fs-16 fSemibold mb-2'>Service Mode <span style={{ color: 'red' }}>*</span></div>
                            <Dropdown 
                                className="border-dblue" 
                                inputClassName={" ht-15"}
                                widthValue={'wt-200'}
                                items={SERVICE_MODES}
                                name="service_mode_id" 
                                displayKey="name" 
                                label="Select"
                                selectedItem={data.service_mode_id && SERVICE_MODES.find(el => el.value === data.service_mode_id)}
                                onSelect={(name) => {
                                    const optionList = (SERVICE_MODES || []).find(el => el.name === name)
                                    this.props.onSelect(optionList, 'service_mode_name', 'service_mode_id')
                                }}
                            />
                    </div>
                    <div className='wt-200 mr-20 mb-20'>
                            <div className='fs-16 fSemibold mb-2'>Distribution Type <span style={{ color: 'red' }}>*</span></div>
                            <Dropdown 
                                className="border-dblue" 
                                inputClassName={" ht-15"}
                                widthValue={'wt-200'}
                                items={DISTRIBUTION_TYPES}
                                name="movement_type" 
                                displayKey="name" 
                                label="Select"
                                selectedItem={data.distribution_mode_id && DISTRIBUTION_TYPES.find(el => el.value === data.distribution_mode_id)}
                                onSelect={(name) => {
                                    const optionList = (DISTRIBUTION_TYPES || []).find(el => el.name === name)
                                    this.props.onSelect(optionList, 'distribution_mode_name', 'distribution_mode_id')
                                }}
                            />
                    </div>
                    <div className='wt-200 mr-20 mb-20'>
                            <div className='fs-16 fSemibold mb-2'>Diesel Base Rate {data.dph_applicable && <span style={{ color: 'red' }}>*</span>} </div>
                            <Input 
                                type={"number"}
                                className="border-dblue" 
                                placeholder="Rate"
                                inputClassName={"ht-15"}
                                value={data.diesel_price_rate}
                                onChange={(e) => {
                                    this.props.onChange(e, 'diesel_price_rate')
                                }}
                                
                            />
                    </div>
                    <div className='wt-200 mr-20 mb-20'>
                            <div className='fs-16 fSemibold mb-2'>Diesel Base Price Date {data.dph_applicable && <span style={{ color: 'red' }}>*</span>} </div>
                            <SingleDatePicker 
                                noBorder={true}
                                displayFormat={"DD MMM YYYY"}
                                hideKeyboardShortcutsPanel={true}
                                placeholder={"Date"}
                                numberOfMonths={1}
                                date={data.diesel_price_date && Moment(data.diesel_price_date) || null}
                                onDateChange={(date) => {
                                    if(date)
                                        this.props.onChange(date.format('YYYY-MM-DD') + ' ' + Moment(data.diesel_price_date || new Date()).format('HH:mm'), 'diesel_price_date');
                                }}
                                focused={this.state.focusedETA} 
                                onFocusChange={({ focused }) => { this.setState({ focusedETA: focused }) }}
                                isOutsideRange={() => false}  
                            />
                    </div>
                </div>}
                {([1,2,3,5].includes(data.contract_type_id)) && <div className='mt-20 ht-90 pv-20 ph-20 bg-white br-5' style={{'border': '1px solid #85919E'}}>
                    <div className='fs-20 header-color fSemibold'>Upload Lanes</div>
                        <div className='content-bgColor pv-20 ph-10 mt-5 br-2 flex'>
                            {isView ? 
                                <button className='trips-upload-doc mr-30 theme-color fSemibold fs-16' onClick={() => this.props.downloadTripsTemplate(true)}>
                                    <DownloadIcon width="16" height="16"  className="mr-5 curP"/>
                                    <span>Template</span>
                                </button>
                            :
                            <>
                                <button className='trips-upload-doc mr-30 theme-color fSemibold fs-16' onClick={() => this.props.downloadTripsTemplate()}>
                                    <DownloadIcon width="16" height="16"  className="mr-5 curP"/>
                                    <span>Template</span>
                                </button>
                                <div className='trips-upload-doc mr-30 tCenter'>
                                    <Upload onChange={this.props.uploadTrips} className="theme-color fs-16 tCenter" isRelative={true}>
                                        <UploadIcon className="wt-18 ht-18 curP"/>
                                        <span className='ml-5 fSemibold'>Upload</span>
                                    </Upload>
                                </div>
                            </>}
                        </div>
                </div>}
               
                 {[1,2].includes(data.contract_type_id) && 
                <LCLContract 
                    trips={data.trips}
                    onChangeTrips={this.props.onChangeTrips}
                    onAddTrip={this.props.onAddTrip}
                    onDeleteTrip={this.props.onDeleteTrip}
                    onEditDeleteTrip={this.props.onEditDeleteTrip}
                    contractTypeId={data.contract_type_id}
                    pricingBasis={pricingBasis}
                    isView={isView}
                    isEdit={isEdit}
                    data={data}
                    nonMandatoryConditions = {this.nonMandatoryConditions()}
                    searchText={searchText}
                    onSearchTrip={this.props.onSearchTrip}
                    searchedSecondaryCotractRfqTrips={this.props.searchedSecondaryCotractRfqTrips}
                />}

                {[3].includes(data.contract_type_id) && <DedicatedContracts
                    trips={data.trips}
                    onChangeTrips={this.props.onChangeTrips}
                    onAddTrip={this.props.onAddTrip}
                    onDeleteTrip={this.props.onDeleteTrip}
                    contractTypeId={data.contract_type_id}
                    onChangeTripsTouchPoints={this.props.onChangeTripsTouchPoints}
                    vehicleTypes={vehicleTypes}
                    isView={isView}
                    isEdit={isEdit}
                    onEditDeleteTrip={this.props.onEditDeleteTrip}
                    pricingBasis={pricingBasis}
                    onChangeDedicatedVC={onChangeDedicatedVC}
                    onDeleteDedicatedVC={onDeleteDedicatedVC}
                    onAddDedicatedVC={onAddDedicatedVC}
                    searchText={searchText}
                    onSearchTrip={this.props.onSearchTrip}
                    searchedSecondaryCotractRfqTrips={this.props.searchedSecondaryCotractRfqTrips}
                />}

                {[4].includes(data.contract_type_id) && 
                <CFAContract 
                    trips={data.trips}
                    onChangeTrips={this.props.onChangeTrips}
                    onAddTrip={this.props.onAddTrip}
                    onDeleteTrip={this.props.onDeleteTrip}
                    cfaDetails={cfaDetails}
                    isView={isView}
                    isEdit={isEdit}
                    onEditDeleteTrip={this.props.onEditDeleteTrip}
                    searchText={searchText}
                    onSearchTrip={this.props.onSearchTrip}
                    searchedSecondaryCotractRfqTrips={this.props.searchedSecondaryCotractRfqTrips}
                />}

                {[5].includes(data.contract_type_id) && <FTLContract 
                    trips={data.trips}
                    onChangeTrips={this.props.onChangeTrips}
                    onAddTrip={this.props.onAddTrip}
                    onDeleteTrip={this.props.onDeleteTrip}
                    contractTypeId={data.contract_type_id}
                    onChangeTripsTouchPoints={this.props.onChangeTripsTouchPoints}
                    vehicleTypes={vehicleTypes}
                    isView={isView}
                    isEdit={isEdit}
                    onEditDeleteTrip={this.props.onEditDeleteTrip}
                    pricingBasis={pricingBasis}
                    searchText={searchText}
                    onSearchTrip={this.props.onSearchTrip}
                    searchedSecondaryCotractRfqTrips={this.props.searchedSecondaryCotractRfqTrips}
                />}
                <div className='flex flex-right mt-20'>
                    <button className='border-dblue wt-150 ht-40 fs-16 fSemibold dark-blue mr-30' onClick={() => this.props.onChangePage(1)}>Previous</button>
                    {!isView && <button className={Cx('button-bg-color wt-150 ht-40 fs-16 fSemibold white-color', {'notselectable': this.validate()})} onClick={this.props.onSaveRFQ} >{isEdit ? 'Update' : 'Save'}</button>}
                    
                </div>
            </div>
        )
    }
}

export default TripDetails;